<!--  -->
<template>
    <div class='wrapper_xx2'>
        <div class="title">认证时间统计</div>
        <div id="echart_xxx_sj11" style="width:100%;height:80%"></div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import echarts from 'echarts'
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            mon:[],
            handelData:[],
            handelTag:'',
            data:[]
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getData(){
            // this.$get(this.urlobj.getDailyHandleCount,{
            //     type:2
            // }).then(res=>{
            //     this.mon = res.rows.map(item=>item.dateTime)
            //     let handelData = res.rows.map(item=>item.handleCount)
            //     this.handelData = this.$util.handleNumber(handelData).numArr
            //     this.handelTag = this.$util.handleNumber(handelData).tag
            //     this.$nextTick(()=>{
            //         this.initEcharts()
            //     })
            // })
            let x = []
            let y = []
            for(let i = 1 ;i<13;i++){
                x.push(i)
            }
            for(let i = 10 ;i<130;i+=10){
                y.push(i)
            }
            this.mon = x
            this.data = y
            this.initEcharts()
            // console.log(this.mon,this.data)
            // this.$nextTick(()=>{
            //         this.initEcharts()
            //     })
        },
        initEcharts(){
            let echart = echarts.init(document.getElementById('echart_xxx_sj11'));
        
            let option = {
                xAxis: {
                
                    data: [1,2,3],
                    barCategoryGap: '15px',                    
                    axisLabel: {
                        textStyle: {
                            color: '#fff'
                        }
                    },
                    axisLine:{show: false}
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        textStyle: {
                            color: '#E78A08'
                        },
                        // formatter: '{value}' + this.handelTag,
                    },
                    splitLine:{show: false},//去除网格线
                    axisLine:{show: false}
                },
                legend: {
                    data: ['社保','高龄津贴'],
                    right:'center',
                    textStyle:{
                        color:'#fff'
                    }
                },
                grid: {
                    containLabel: true,
                    left: '10%',
                    top: "10%",
                    bottom: "10%",
                },
                series: [{
                    name:'社保',
                    data: [10,20,30],
                    type: 'line',
                    smooth:true,
                    symbol: 'none',
                    lineStyle:{
                        color:'rgba(0, 160, 233, 1)'
                    },
                    itemStyle:{
                        color:'rgba(0, 160, 233, 1)'
                    },
                    areaStyle:{
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: 'rgba(0, 174, 255, 1)'
                            }, {
                                offset: 1, color: 'rgba(6, 27, 84, 0)' // 100% 处的颜色
                            }],
                        }
                    }
                },{
                    name:'高龄津贴',
                    data: [40,70,30],
                    type: 'line',
                    smooth:true,
                    symbol: 'none',
                    lineStyle:{
                        color:'#FF9600'
                    },
                    itemStyle:{
                        color:'#FF9600'
                    },
                    areaStyle:{
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [{
                                offset: 0, color: '#D86B13'
                            }, {
                                offset: 1, color: 'rgba(6, 27, 84, 0)' // 100% 处的颜色
                            }],
                        }
                    }
                }],
                tooltip:{
                    trigger:'axis',
                    // formatter:'{c}'+this.handelTag,
                    backgroundColor:'rgba(255,255,255,0)',
                    textStyle:{
                        color:'#00B879'
                    }
                }
            };
            

            echart.setOption(option)
           
        }
        
    },
    watch: {
        data() {
            this.initEcharts()
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getData()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.wrapper_xx2{
    height:100%!important;
    width:100%!important;
    background-image: url('../../../../assets/images/monitorpy/leftbottom.png');
    background-size: 100% 100%;
}
.title{
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    padding-left: 40px;
    padding-top: 20px;
    box-sizing:border-box
}

</style>